import { Container } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { TranslationKeys } from '../../../locale/keys';
import { Header } from '../../molecules/Header';
import { ValueLabelWithImage } from '../../molecules/Header/Header.types';

export const BackgroundContext = React.createContext<{
  setBackground: (key: string | null) => void;
}>({
  setBackground: () => {},
});

export const Layout: React.FC<{ pages: ValueLabelWithImage<string, TranslationKeys>[] }> = ({
  children,
  pages,
}) => {
  const [background, setBackground] = React.useState<string | null>(null);
  return (
    <>
      <Header pages={pages} />
      <BackgroundContext.Provider value={{ setBackground }}>
        <Container
          maxWidth={false}
          sx={{
            minHeight: '100vh',
            width: '100vw',
            p: 4,
            pt: 8,
            backgroundImage: background ? `url(${background})` : '',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            boxShadow: '2px 5px 10px black',
          }}
        >
          {children}
        </Container>
        <Container
          sx={{
            display: 'flex',
            backgroundColor: 'custom.opaqueBlue',
            width: '100vw',
            justifyContent: 'space-around',
            pb: '5px',
          }}
          maxWidth={false}
        >
          <Link style={{ color: 'white' }} to="/impressum">
            Impressum
          </Link>
        </Container>
      </BackgroundContext.Provider>
    </>
  );
};
